export const selectIsTakingSchemeScreenshot = (state) => state.schemes.isTakingScreenshot;
// SCHEMES
export const selectSchemes = (state) => state.schemes.schemes; // paginated & filtered schemes
export const selectAllSchemes = (state) => state.schemes.allSchemes; // full list of schemes for module (or without module)
export const selectSchemesCount = (state) => state.schemes.schemesCount;
export const selectCreatedSchemeId = (state) => state.schemes.createdSchemeId;

export const selectScheme = (state) => state.schemes.scheme;
export const selectGetSchemesStatus = (state) => state.schemes?.getSchemesStatus;
export const selectGetAllSchemesStatus = (state) => state.schemes.getAllSchemesStatus;

export const selectGetSchemesErrorInfo = (state) => state.schemes.getSchemesError;
export const selectGetAllSchemesErrorInfo = (state) => state.schemes.getAllSchemesError;
export const selectGetSchemeStatus = (state) => state.schemes.getSchemeByIdStatus;
export const selectGetSchemeErrorInfo = (state) => state.schemes.getSchemeByIdError;
export const selectAddSchemeStatus = (state) => state.schemes.addSchemeStatus;
export const selectAddSchemeErrorInfo = (state) => state.schemes.addSchemeError;
export const selectEditSchemeStatus = (state) => state.schemes.editSchemeStatus;
export const selectEditSchemeErrorInfo = (state) => state.schemes.editSchemeError;
export const selectDeleteSchemeStatus = (state) => state.schemes?.deleteSchemeStatus;
export const selectDeleteSchemeErrorInfo = (state) => state.schemes.deleteSchemeError;

// TREX
export const selectTrexStatus = (state) => state.schemes.trexStatus;
export const selectGetTrexStatus = (state) => state.schemes.getTrexStatus;
export const selectGetTrexStatusError = (state) => state.schemes.getTrexStatusError;
export const selectStartTrexStatus = (state) => state.schemes.startTrexStatus;
export const selectStartTrexError = (state) => state.schemes.startTrexError;
export const selectStopTrexStatus = (state) => state.schemes.stopTrexStatus;
export const selectStopTrexError = (state) => state.schemes.stopTrexError;
export const selectDevicesAvailableForSchemes = (state) => state.schemes.devicesAvailableForSchemes;
export const selectGetDevicesAvailableForSchemesStatus = (state) => state.schemes.getDevicesAvailableForSchemesStatus;
export const selectDevicesRequiredForScheme = (state) => state.schemes.devicesRequiredForScheme;
export const selectGetDevicesRequiredForSchemeStatus = (state) => state.schemes.getDevicesRequiredForSchemeStatus;
